import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PersonNameDTO} from '../../../models/PersonNameDTO';

@Component({
  selector: 'app-edit-person-name-dialog',
  templateUrl: './edit-person-name-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class EditPersonNameDialogComponent implements OnInit {

  fullNameFormGroup: FormGroup;
  firstNameFormControl: FormControl;
  middleNameFormControl: FormControl;
  lastNameFormControl: FormControl;
  personNameDTO: PersonNameDTO;

  constructor(
    public dialogRef: MatDialogRef<EditPersonNameDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PersonNameDTO
  ) {
    this.personNameDTO = data;

    this.firstNameFormControl = new FormControl(this.personNameDTO.firstName, Validators.required);
    this.middleNameFormControl = new FormControl(this.personNameDTO.middleName);
    this.lastNameFormControl = new FormControl(this.personNameDTO.lastName, Validators.required);

    this.fullNameFormGroup = this.formBuilder.group({
      firstName: this.firstNameFormControl,
      middleName: this.middleNameFormControl,
      lastName: this.lastNameFormControl
    });
  }

  ngOnInit(): void {}

  onSaveClick(): void {
    if (this.fullNameFormGroup.valid) {
      this.personNameDTO.firstName = this.firstNameFormControl.value;
      this.personNameDTO.middleName = this.middleNameFormControl.value;
      this.personNameDTO.lastName = this.lastNameFormControl.value;
      this.dialogRef.close(this.personNameDTO);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
